var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBidIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.66669C9.37466 6.66669 2.66666 8.72802 2.66666 12.6667C2.66666 16.6054 9.37466 18.6667 16 18.6667C22.6267 18.6667 29.3333 16.6054 29.3333 12.6667C29.3333 8.72802 22.6267 6.66669 16 6.66669ZM9.33332 19.9174V23.9174C10.9827 24.316 12.8067 24.56 14.6667 24.6387V20.6387C12.87 20.5687 11.0841 20.3272 9.33332 19.9174ZM17.3333 20.6374V24.6374C19.1301 24.5688 20.9162 24.3272 22.6667 23.916V19.916C20.9162 20.3272 19.1301 20.5688 17.3333 20.6374ZM25.3333 19.0627V23.0627C27.7347 22.056 29.3333 20.5867 29.3333 18.6667V14.6667C29.3333 16.5867 27.7347 18.056 25.3333 19.0627ZM6.66666 23.0627V19.0627C4.26666 18.056 2.66666 16.5854 2.66666 14.6667V18.6667C2.66666 20.5854 4.26666 22.056 6.66666 23.0627Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBidIcon);
export default __webpack_public_path__ + "static/media/BidIcon.bcda9ed1bd651cefa1bcfeca82a1cb43.svg";
export { ForwardRef as ReactComponent };